const fridgeMsg = "Please collect from display fridge";
const retailMsg = "Please collect from retail display";
const lunchAndEveningMsg = {
  body: "Lunch is available from 11AM",
  Heading: "Lunch Unavailable"
};
const coffeeNotSelectedMsg = "Please add a coffee.";
const breakfastMsg = {
  heading: "Breakfast Unavailable",
  body: function(time) {
   return `Breakfast is available until ${time}`;
  },
}

export const MESSAGES = Object.freeze({
  info: {
    Coffee: "",
    Smoothie: "",
    Breakfast: breakfastMsg,
    "Cold Drinks": fridgeMsg,
    Lunch: lunchAndEveningMsg,
    "Grab and Go": fridgeMsg,
    Kids: "",
    Bakery: "",
    Snacks: retailMsg,
    "Lunch & Evening": lunchAndEveningMsg,

  },
  warning: {
    coffeeNotSelected: coffeeNotSelectedMsg
  }
});


export const getMealMessage = (category) => {
  const timeStamp = new Date().toISOString(); // Get UTC timestamp
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // Get user's timezone

  // Convert UTC time to local time
  const localTime = new Date(timeStamp).toLocaleString("en-US", { timeZone });
  const localHours = new Date(localTime).getHours();

  if (category === "Breakfast" && localHours >= 11) {
    return {
      show: true,
      heading: "Breakfast Unavailable",
      body: "Breakfast is available until 11AM",
    };
  } else if (category === "Lunch & Evening" && localHours < 11) {
    return {
      show: true,
      heading: "Lunch Unavailable",
      body: "Lunch is available from 11AM",
    }
  } else if (category === "Kids" && localHours < 11) {
    return {
      show: true,
      heading: `${category} Unavailable`,
      body: `${category} is available from 11AM`,
    }
  }

  return { show: false, body: "", heading: "" }; // Don't show modal if conditions are not met
};

